import type { paths } from '@pba/types-openapi-node';
import type { BodyRequest } from '@pba/utils';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type GetInvitationTokenRequestBody = paths['/invitation-tokens']['post']['requestBody']['content']['application/json'];
type GetInvitationTokenResponse =
  paths['/invitation-tokens']['post']['responses']['default']['content']['application/json'];

export const getInvitationToken = async ({ body }: BodyRequest<GetInvitationTokenRequestBody>) =>
  nodeApiClient.post<GetInvitationTokenResponse, ApiClientResponse<GetInvitationTokenResponse>>(
    nodeApiRoutes.invitationTokens.create,
    body,
  );
